import axios from 'axios';
//import config from "../config"; // Ensure this contains your API_URL

const API_URL = 'http://localhost:8000/api';

export const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  MEDIA_URL: process.env.REACT_APP_MEDIA_URL || 'http://localhost:8000/media',
};



// Function to fetch and store CSRF token
export const getCSRFToken = async () => {
    try {
        const response = await axios.get(`${config.API_URL}/api/users/csrf/`, {
            withCredentials: true, // Ensures cookies are included
        });

        console.log("CSRF token set:", document.cookie);
        return response.data.csrfToken;
    } catch (error) {
        console.error("Error fetching CSRF token:", error);
    }
};





// Create an axios instance with base configuration
const api = axios.create({
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  });

// Add interceptor to include auth token with every request
api.interceptors.request.use(
    config => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    error => Promise.reject(error)
  );

// API services
export const apiService = {
  // Projects
  getProjects: () => api.get('/projects/'),
  getProject: (id) => api.get(`/projects/${id}/`),
  
  // Services
  getServices: () => api.get('/services/'),
  getService: (id) => api.get(`/services/${id}/`),
  
  // Contact
  sendContactMessage: (data) => api.post('/contact/', data),
};

// Auth services
export const authService = {
  login: async (email, password) => {
    try {
      console.log("LOG ", email)
      const response = await api.post('/token/', { email, password });
      console.log('log ', response.data);
      if (response.data.access) {
        localStorage.setItem('token', response.data.access);
        localStorage.setItem('refresh_token', response.data.refresh);
        
        // Fetch user data separately since token endpoint doesn't return it
        try {
          const userResponse = await api.get('/users/me/', {
            headers: {
              'Authorization': `Bearer ${response.data.access}`
            }
          });
          console.log('User au service:', userResponse.data);
          localStorage.setItem('user', JSON.stringify(userResponse.data));
        } catch (userError) {
          console.error('Error fetching user data:', userError);
          // Still continue with login even if user data fetch fails
        }
      }
      return response.data;
    } catch (error) {
      console.log("LOG EROR",error.response)
      throw error.response ? error.response.data : new Error('Network error');
    }
  },
  
  register: async (username, email, password, first_name = '', last_name = '') => {
    try {
      const response = await api.post('/users/register/', { 
        username, 
        email, 
        password,
        first_name,
        last_name
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
  },
  
  // Add password reset functionality
  requestPasswordReset: async (email) => {
    try {
      // Use the correct endpoint path that matches your Django URL configuration
      const response = await axios.post(`${config.API_URL}/api/auth/password/reset/`, {
        email: email
      });
      return response.data;
    } catch (error) {
      console.error('Password reset request error:', error.response || error);
      
      // Check if this is an email configuration error
      if (error.response && error.response.status === 500) {
        // Provide a more user-friendly error message for email server issues
        throw {
          detail: "Le serveur de messagerie n'est pas configuré correctement. Veuillez contacter l'administrateur."
        };
      }
      
      throw error.response ? error.response.data : new Error('Network error');
    }
  },
  
  // Confirm password reset with token
  confirmPasswordReset: async (uid, token, new_password1, new_password2) => {
    try {
      console.log('Password reset confirm payload:', {
        uid, token, new_password1, new_password2
      });
      
      // dj-rest-auth s'attend à un format spécifique pour le uid et token
      // Le uid doit être décodé de base64 et le token doit être exactement comme fourni dans l'URL
      const response = await axios.post(`${config.API_URL}/api/auth/password/reset/confirm/`, {
        uid: uid,
        token: token,
        new_password1: new_password1,
        new_password2: new_password2
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      console.log('Password reset confirm response:', response.data);
      return response.data;
    } catch (error) {
      // Afficher les détails spécifiques de l'erreur pour le débogage
      if (error.response && error.response.data) {
        console.error('Détails de l\'erreur:', JSON.stringify(error.response.data, null, 2));
      }
      console.error('Password reset confirmation error details:', error.response?.data || error);
      throw error.response ? error.response.data : new Error('Network error');
    }
  },
  
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    console.log(userStr);
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch (error) {
        console.error('Error parsing user data:', error);
        return null;
      }
    }
    return null;
  },
  
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },
  
  getUserRole: () => {
    // First try to get role from localStorage user object
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        // Check if the string starts with a quote or brace (valid JSON)
        if (userStr.trim().startsWith('{') || userStr.trim().startsWith('"')) {
          const userData = JSON.parse(userStr);
          if (userData && userData.role) {
            return userData.role;
          }
        } else {
          // If it's not valid JSON, it might be just a username string
          console.log('User data is not in JSON format:', userStr);
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }
    
    // If no role in user object, try to get from token
    const token = localStorage.getItem('token');
    if (!token) return 'visitor';
    
    try {
      // Decode the JWT token to get user information
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      // Check if role exists in token, otherwise return default
      return tokenData.role || 'visitor';
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'visitor';
    }
  },
  
  // Add the googleLogin function to the exported object
  // Update the googleLogin function
  googleLogin: async (idToken) => {
    try {
        // Sending Google token to backend:
        console.log('Sending Google token to backend:', idToken.substring(0, 20) + '...');
        
        // First, get a CSRF token
        await getCSRFToken();
        
        // Get the CSRF token from cookies
        const csrfToken = document.cookie
          .split('; ')
          .find(row => row.startsWith('csrftoken='))
          ?.split('=')[1];
        
        const response = await axios.post(`${config.API_URL}/api/users/google/`, {
          id_token: idToken,
          process: 'login'
        }, {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRFToken': csrfToken
          },
          withCredentials: true
        });
        
        console.log('Google login response:', response.data);
        
        // Check for different possible response structures
        if (response.data) {
          // Store the access token - different APIs might use different field names
          if (response.data.access_token) {
            localStorage.setItem('token', response.data.access_token);
          } else if (response.data.access) {
            localStorage.setItem('token', response.data.access);
          } else if (response.data.token) {
            localStorage.setItem('token', response.data.token);
          }
          
          // Store the refresh token if available
          if (response.data.refresh_token) {
            localStorage.setItem('refresh_token', response.data.refresh_token);
          } else if (response.data.refresh) {
            localStorage.setItem('refresh_token', response.data.refresh);
          }
          
          // Store user data if available
          if (response.data.user) {
            localStorage.setItem('user', JSON.stringify(response.data.user));
          } else if (response.data.user_data) {
            localStorage.setItem('user', JSON.stringify(response.data.user_data));
          }
          
          // Log what we're storing to help debug
          console.log('Stored in localStorage:', {
            token: localStorage.getItem('token'),
            refresh_token: localStorage.getItem('refresh_token'),
            user: localStorage.getItem('user')
          });
        }
        
        return response;
    } catch (error) {
        console.error('Google login API error:', error.response || error);
        throw error;
    }
}
};

// Partner management services
export const partnerService = {
  // Get all partners (for superusers and delta admins)
  getAllPartners: () => api.get('/users/partners/'),
  
  // Get a specific partner
  getPartner: (id) => api.get(`/users/partners/${id}/`),
  
  // Create a new partner (for superusers and delta admins)
  createPartner: (data) => api.post('/users/partners/', data),
  
  // Update a partner (for superusers and delta admins)
  updatePartner: (id, data) => api.put(`/users/partners/${id}/`, data),
  
  // Delete a partner (for superusers and delta admins)
  deletePartner: (id) => api.delete(`/users/partners/${id}/`),
  
  // Get partner admins for a specific partner
  getPartnerAdmins: (partnerId) => api.get(`/users/partners/${partnerId}/admins/`),
  
  // Add a partner admin
  addPartnerAdmin: (data) => api.post('/users/partner-admins/', data),
  
  // Remove a partner admin
  removePartnerAdmin: (id) => api.delete(`/users/partner-admins/${id}/`),
};

// Event management services
export const eventService = {
  // Get all events
  getAllEvents: () => api.get('/events/'),
  
  // Get filtered events
  getFilteredEvents: (queryString) => api.get(`/events/?${queryString}`),
  
  // Get featured events
  getFeaturedEvents: () => api.get('/events/?featured=true'),
  
  // Get upcoming events
  getUpcomingEvents: () => api.get('/events/?upcoming=true'),
  
  // Get a specific event
  getEvent: (id) => api.get(`/events/${id}/`),
  
  // Get event categories
  getEventCategories: () => api.get('/categories/'),
  
  // Create a new event (for partner admins)
  createEvent: (data) => api.post('/events/', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  
  // Update an event (for partner admins)
  updateEvent: (id, data) => api.put(`/events/${id}/`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  
  // Delete an event (for partner admins)
  deleteEvent: (id) => api.delete(`/events/${id}/`),
  
  // Get reservations for an event (for partner admins)
  getEventReservations: (eventId) => api.get(`/events/${eventId}/reservations/`),
};

// Reservation management services
export const reservationService = {
  // Get all reservations (for admins)
  getAllReservations: () => api.get('/reservations/'),
  
  // Get user's reservations (for visitors)
  getUserReservations: () => api.get('/reservations/user/'),
  
  // Create a new reservation
  createReservation: (data) => api.post('/reservations/', data),
  
  // Update a reservation (e.g., upload payment proof)
  updateReservation: (id, data) => api.put(`/reservations/${id}/`, data),
  
  // Cancel a reservation
  cancelReservation: (id) => api.delete(`/reservations/${id}/`),
  
  // Upload payment proof
  uploadPaymentProof: (id, file) => {
    const formData = new FormData();
    formData.append('payment_proof', file);
    return api.post(`/reservations/${id}/upload-payment/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

// User management services (for superusers and delta admins)
export const userManagementService = {
  // Get all users
  getAllUsers: () => api.get('/users/'),
  
  // Get a specific user
  getUser: (id) => api.get(`/users/${id}/`),
  
  // Create a new user
  createUser: (data) => api.post('/users/', data),
  
  // Update a user
  updateUser: (id, data) => api.put(`/users/${id}/`, data),
  
  // Delete a user
  deleteUser: (id) => api.delete(`/users/${id}/`),
  
  // Change user role
  changeUserRole: (id, role) => api.patch(`/users/${id}/`, { role }),
};

export default api;